import { Check } from "lucide-react";
import { LISTING_TYPES } from "./constants";

export const ListingTypeSection = ({ value, onChange }) => (
  <div className="glass-card p-6">
    <h2 className="text-xl text-[#EDEDED] mb-4">Listing Type</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {LISTING_TYPES.map((type) => (
        <label
          key={type.value}
          className={`p-4 rounded-xl border cursor-pointer transition-all ${
            value === type.value
              ? "border-[#D4AF37] bg-[#D4AF37]/10"
              : "border-[#3F3F46] hover:border-[#71717A]"
          }`}
        >
          <input
            type="radio"
            name="listing_type"
            value={type.value}
            checked={value === type.value}
            onChange={(e) => onChange(e.target.value)}
            className="sr-only"
          />
          <div className="flex items-start gap-3">
            <div
              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mt-0.5 ${
                value === type.value ? "border-[#D4AF37] bg-[#D4AF37]" : "border-[#71717A]"
              }`}
            >
              {value === type.value && <Check className="w-3 h-3 text-black" />}
            </div>
            <div>
              <p className="text-[#EDEDED] font-medium">{type.label}</p>
              <p className="text-sm text-[#71717A]">{type.description}</p>
            </div>
          </div>
        </label>
      ))}
    </div>
  </div>
);
